import React from 'react'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import {withI18n} from '../../hocs'
import { Sparkles } from 'lucide-react'
import BoxVideoSentimentsStyled from './styled'

const BoxVideoSentiments = ({videoAnalysis = {}, videoUrl, i18n}) => {
  const auth = localStorage.getItem("persist:auth");
  if (auth && !auth.includes("demo") && !auth.includes("hrbotfactory")) {
    return null
  }
  //const { radar } = videoAnalysis;
  //let videoAnalysisFormatted = videoAnalysis;

  /*
  < Grid item xs={4}>
          <img alt="radar" width={400} src={radar}/>
        </Grid>
        <Grid item xs={5}>
          <Grid container item className="sentiments">
            {videoAnalysisFormatted && Object.entries(videoAnalysisFormatted).map(([key, value]) => {

              if(key === 'created_at' || key === 'radar')
              {
                return null
              }
              return (<Grid className="sentimentsItem" item key={key}>
                <LinearPercentWithTitle key={key} title={i18n.videoSentiments[key]} value={Math.round(value * 100)}/>
              </Grid>)
            })}
          </Grid>
        </Grid>

*/

  return (
    <BoxVideoSentimentsStyled>
      <div className="header-table">
        <p>
          {i18n.videoSentiments.title}
        </p>
      </div>
      <div className="boxInfo">
        <div className="video-wrapper">
          <video controls>
            <source type="video/mp4" src={videoUrl}/>
          </video>
        </div>
        <div className="summary">
          <p className="summary-title">
            <Sparkles size={16} />
            {i18n.iaFake.title}
          </p>
          <p className="summary-text">{i18n.iaFake.description}</p>
        </div>
      </div>
    </BoxVideoSentimentsStyled>
  )
}

BoxVideoSentiments.propTypes = {
  i18n: PropTypes.object.isRequired,
  variableFields: PropTypes.object
}

const enharce = compose(withI18n)

export default enharce(BoxVideoSentiments)
